// Hotel-Edition module "LinkedIn-Beiträge" (PLAN.md §7.3, part B1): PillarPosts filtered server-side to
// platform = linkedin, in hotel language. Agencies keep /pillar-posts unchanged.
import PillarPosts from "@/pages/PillarPosts";

export default function LinkedInBeitraege() {
  return <PillarPosts variant="hotel-linkedin" />;
}
